import { render, staticRenderFns } from "./PlannedServiceIndex.vue?vue&type=template&id=b124a44e&scoped=true&"
import script from "./PlannedServiceIndex.vue?vue&type=script&lang=js&"
export * from "./PlannedServiceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b124a44e",
  null
  
)

export default component.exports